export default __webpack_public_path__ + "static/media/2_bowlOfGems.b58bbc94.png";